module.exports = __webpack_public_path__ + "media/newstyle/images/instagram-c0113239bc87d217189205448af0e84a.svg";